import BookDemoForm, {
  getServerSideProps as originalGetServerSideProps,
} from '@/pages/bookafreehomedemo';
export default BookDemoForm;
export { originalGetServerSideProps as getServerSideProps };
